import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=633d8b2e&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=633d8b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d8b2e",
  null
  
)

export default component.exports